// This file is auto-generated at build time by scripts/generate-build-info.js.
// The committed value is only a fallback used during local dev (ng serve),
// where the prebuild hook does not run. Real builds overwrite it with a unique id.
export const BUILD_ID = '1793719244441';
